var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#4A24A5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9922,
    y: 11.3047,
    width: 4.01338,
    height: 17.3913,
    fill: "#8DE24A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6953,
    y: 17.9922,
    width: 4.01338,
    height: 17.3913,
    transform: "rotate(90 28.6953 17.9922)",
    fill: "#8DE24A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCross);
export default __webpack_public_path__ + "static/media/round-cross.fa289762bba051060f1f74f628286e70.svg";
export { ForwardRef as ReactComponent };